var map = {
	"./Q1001.webp": 9031,
	"./Q1002.webp": 2579,
	"./Q1003.webp": 9617,
	"./Q1004.webp": 4400,
	"./Q3000.webp": 7222,
	"./Q4000.webp": 1228,
	"./quiz_end_again.webp": 6231,
	"./quiz_index_2.webp": 5071,
	"./quiz_suggested_route.webp": 7120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5904;